import { render, staticRenderFns } from "./UserAddresses.vue?vue&type=template&id=47f25ede&scoped=true&"
import script from "./UserAddresses.vue?vue&type=script&lang=js&"
export * from "./UserAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f25ede",
  null
  
)

export default component.exports